module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA9klEQVRIie2VTQsBURiFz/jMSlEW/CV7C3/Gn5FoJKQRakqKZGFlIdQ0G5sRkq+6d/RaGd07vjeaZzfzvuecO3VmRlEQs/FDfL80hxfgBXyFwK1JOptBNB77yHdtWWjkS+InCASDHx86FA47rh0BnUoNnLO3zUnbLlflAbvNFnpdg22//vUgDWnJQxpALA0T4/7g5QDSkPYeYYsmozGM6fxpc9oljQhpTXvNFtYr66E57dCuDNf3QCuoOB9P0jnNaMcN1wDOOLSiKmwW3bvOGH8/gBA1S9YYEX4FkdwzIYf9HolUEpwxDPUuzNnioTnh/TL/PQDABQWneRXjyMLUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down-arrow@2x.png
// module id = jGtd
// module chunks = 0